export default "__VITE_ASSET__8lQVS9tz__"